import React from 'react';
import './ModalAlert.css';
import Button from '../Button/Button';

const ModalAlert = ({ 
  isOpen, 
  onClose,
  title = {
    text: '',
    highlight: ''
  },
  message,
  confirmText = 'Accept',
  cancelText = 'Cancel',
  onConfirm = onClose,
  acecept = false,
  onAccept
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-alert-overlay">
      <div className="modal-alert-content">
        <div className="modal-alert-header">
          <h2 className="modal-alert-title">
            <span className="title-text">
              {title.text} <span className="highlight">{title.highlight}</span>
            </span>
          </h2>
        </div>
        <div className="modal-alert-body">
          <p>{message}</p>
        </div>
        <div className="modal-alert-footer">
          <Button 
            onClick={onClose}
            variant="error"
            borderRadius={20}
            fullWidth
          >
            {cancelText}
          </Button>
          <Button 
            onClick={acecept ? onAccept : onConfirm}
            variant="primary"
            borderRadius={20}
            fullWidth
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalAlert;
